import { RouteRecordRaw } from 'vue-router';
import {
  DocumentManagementDocumentsPage,
  DocumentManagementLocationsPage,
  DocumentManagementPage,
  DocumentManagementSendControlRootPage,
  DocumentManagementSendControlPage,
  DocumentManagementSendCreatePage,
  DocumentManagementSendListPage,
} from '@/pages/document-management';

export const routeName = 'GestaoDocumentos';

const documentManagementPermissions = [{ action: 'manage', subject: 'DocumentManagement' }];
const documentSendPermissions = [{ action: 'send', subject: 'Document' }];
const combinedDocumentSendPermissions = [
  { action: 'manage', subject: 'DocumentManagement' },
  { action: 'send', subject: 'Document' },
];
const documentSendReportPermissions = [
  { action: 'manage', subject: 'DocumentManagement' },
  { action: 'send', subject: 'Document' },
];

export const route: RouteRecordRaw = {
  path: 'gestao-documentos',
  name: routeName,
  component: DocumentManagementPage,
  redirect: { name: 'GestaoDocumentosListaDocumentos' },
  meta: {
    requiresAuth: true,
    breadcrumb: 'Gestão de Documentos',
    permissions: documentManagementPermissions,
  },
  children: [
    {
      path: 'lista-documentos',
      name: 'GestaoDocumentosListaDocumentos',
      component: DocumentManagementDocumentsPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Lista de Documentos',
        permissions: documentManagementPermissions,
      },
    },
    {
      path: 'controle-envio',
      component: DocumentManagementSendControlRootPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Controle de Envio',
        permissions: documentManagementPermissions,
      },
      children: [
        {
          path: '',
          name: 'GestaoDocumentosControleEnvio',
          component: DocumentManagementSendControlPage,
          meta: {
            requiresAuth: true,
            breadcrumb: 'Controle de Envio',
            permissions: documentManagementPermissions,
          },
        },
        {
          path: 'enviar',
          name: 'GestaoDocumentosControleEnvioEnviar',
          component: DocumentManagementSendCreatePage,
          meta: {
            requiresAuth: true,
            breadcrumb: 'Enviar',
            permissions: combinedDocumentSendPermissions,
            matchMode: 'any',
          },
        },
        {
          path: 'lista-envio',
          name: 'GestaoDocumentosControleEnvioListaEnvio',
          component: DocumentManagementSendListPage,
          meta: {
            requiresAuth: true,
            breadcrumb: 'Lista de Envio',
            permissions: documentSendReportPermissions,
          },
        },
      ],
    },
    {
      path: 'locais-htm',
      name: 'GestaoDocumentosLocaisHTM',
      component: DocumentManagementLocationsPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Locais HTM',
        permissions: documentManagementPermissions,
      },
    },
  ],
};
